<template>
<div
  class="lending-term"
>
  <HeaderTerm
    title="Termo Comodato"
    :imgsrc="urlImages.imgTermLending"
    :event-id="ticket.eventId"
    :ticket-id="ticket._id"
  />

  <div class="row">
    <div class="col-xs-12">
      <p>
        A {{ fullname }}, pessoa jurídica de direito privado, com sede em {{ fulladdress }}, inscrita no CNPJ sob o no. {{ cnpj }} e Inscrição Estadual no. {{ numberState }}, doravante denominada {{ abbreviation }}, e o(a)<span style="text-transform: capitalize;">{{ customer.holder }}</span>, residente e domiciliado(a) na {{ customer.address.street }}, {{ customer.address.number }}, {{ customer.address.complement }} - {{ customer.address.neighborhood }} - {{ customer.address.zip }}, na cidade de {{ customer.address.city }}, {{ stateName }}, UC n.o {{ customer.uc }}, firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:
      </p>
      <h5>CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES</h5>
      <ol>
        <li>
          A {{ shortname }} está desenvolvendo o "{{ projectName }}" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;
        </li>
        <li>
          No tocante às práticas relacionadas ao uso racional de energia elétrica, enquandra-se como tal, entre outras, a substituição de geladeiras;
        </li>
        <li>
          A {{ shortname }} buscando viabilizar essa prática nas comunidades atendidas pelo "{{ projectName }}", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda desteinstrumento.
        </li>
      </ol>
      <h5>CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO</h5>
      <ol>
        <li>
          A {{ shortname }} substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da {{ shortname }};
        </li>
        <li>
          A geladeira entregue pela {{ shortname }} ao consumidor, será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma.
        </li>
        <li>
          Ao serem entregues a novas geladeiras pela {{ shortname }}, o consumidor se obriga e entregar aquela que se encontra em sua residência, passando esta a ser de propriedade da
          <strong>3E Engenharia</strong>;
        </li>
        <li>
          Após o término do prazo determinado no item 2.2 desta cláusula, a geladeira entregue pela {{ shortname }} em comodato, passa a ser de propriedade do consumidor;
        </li>
        <li>
          O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a {{ shortname }}.
        </li>
      </ol>
      <h5>CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR</h5>
      <ol>
        <li>
          O consumidor se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do “Projeto {{ shortname }} Comunidades” cancelados, sendo a geladeira objeto do comodato emreferência, recolhida imediatamente pela {{ shortname }};
        </li>
        <li>
          O consumidor, desde já, autoriza a qualquer momento, a inspeção pelos funcionários da {{ shortname }}, para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o consumidor terá todos os benefícios oriundos do “{{ projectName }}” cancelados.
        </li>
      </ol>
      <p>
        <span class="captalize">{{ customer.address.city }}/{{ config.state }}</span>
        , {{ new Date | moment('LLL') }}
      </p>
    </div>
  </div>
  <signature-customer-ticket :customer="customer"/>
</div>
</template>
<script>
import SignatureCustomerTicket from '../../SignatureCustomerTicket'
import { mapActions, mapGetters } from 'vuex'
import HeaderTerm from '../HeaderTerm'

export default {
  name: 'lending-term-iasc-ma',
  components: { SignatureCustomerTicket, HeaderTerm },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    customer: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapGetters('project', ['urlImages']),
    stateName: function () {
      return 'Maranhão'
    },
    fullname: function () {
      return this.longname + ' - ' + this.abbreviation
    },
    longname: function () {
      return 'Companhia Energética do Maranhão'
    },
    abbreviation: function () {
      return 'CEMAR'
    },
    projectName: function () {
      return 'IASC 2019'
    },
    fulladdress: function () {
      return `${this.address.type} ${this.address.street}, nº ${this.address.number} – ${this.address.neighborhood}, ${this.address.city}/${this.address.state}`
    },
    address: function () {
      return {
        type: 'Alameda',
        street: 'Alameda A, Quadra SQS',
        number: '100',
        neighborhood: 'Loteamento Quintadinha',
        city: 'Altos do Calhau',
        state: 'MA'
      }
    },
    cnpj: function () {
      return '06.272.793/0001-84'
    },
    numberState: function () {
      return '06.105.848-3'
    }
  },

  methods: {
    ...mapActions('project', ['getImagesProject'])
  },

  mounted () {
    this.getImagesProject()
  }
}
</script>
<style scoped>

  .captalize {
    text-transform: capitalize;
  }

  p, li {
    font-size: 8pt;
    text-align: justify;
  }

  table {
    border-spacing: 0.5rem;
    width: 100%;
  }

  td, th {
    text-align: center;
    border: 1px solid #999;
    padding: 0.5rem;
  }

  th {
    background-color: #ddd;
  }

  td {
    padding-bottom: 2cm;
    width: 25%;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/IascMa/LendingTermIascMa.vue